export default __webpack_public_path__ + "static/media/preview.d8e88478.png";